import React, { forwardRef, useCallback } from 'react';
import { css, cx } from '@emotion/css';
import { theme } from '@contrast-security-inc/design-system-foundations';
import { validLabelFonts } from '../shared';
import { IconInputBase, iconInputStyles } from '../IconInputBase/IconInputBase';
const toggleStyles = css `
  display: inline-block;
  border-radius: 100px;
  padding: 2px;
  width: 48px;
  height: 28px;
  box-sizing: border-box;

  &::before {
    display: block;
    content: "";
    width: 24px;
    height: 24px;
    border-radius: 30px;
    background: ${theme.color.white};
  }

  transition: padding-left 0.2s;
`;
const toggleInputStyles = css `
  &:checked + label span {
    padding-left: 22px;
    box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5), inset 0 0 0 50px ${theme.color.turquoise70};
  }

  &:not(:checked) + label span {
    box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5), inset 0 0 0 50px ${theme.color.neutral60};
  }

  &:disabled + label span {
    opacity: 0.3;
  }

  &:focus-visible + label span {
    border: 3px solid ${theme.color.neutral100};
    padding-top: 0px;
    padding-bottom: 0px;

    ::before {
      width: 22px;
      height: 22px;
      margin-left: -2px;
    }
  }

  &:focus-visible:not(:checked) + label span {
    border: 3px solid ${theme.color.turquoise70};
  }

  &:not(:checked, :disabled) + label span:hover {
    box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5), inset 0 0 0 50px ${theme.color.neutral80};
  }

  &:checked:not(:disabled) + label span:hover {
    box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5), inset 0 0 0 50px ${theme.color.turquoise90};
  }
`;
export const Toggle = forwardRef(({ 'aria-label': ariaLabel, className, error, errorPlacement, font, id, isChecked = false, isDisabled, label, onChange, ref: _ref, style, testId, useInlineError, value, ...rest }, ref) => {
    const changeHandler = useCallback((event) => (!isDisabled ? onChange(event, event?.target?.checked) : undefined), [onChange, isDisabled]);
    if (font && !validLabelFonts.includes(font)) {
        throw new Error(`Invalid label font, valid fonts are ${validLabelFonts} and you passed in ${font}.`);
    }
    return (React.createElement(React.Fragment, null, React.cloneElement(React.createElement(IconInputBase, { "aria-label": ariaLabel, className: cx(className, 'ds-toggle'), error: error, errorPlacement: errorPlacement, font: font, id: id, isDisabled: isDisabled, label: label, renderInput: () => (React.createElement("input", { checked: isChecked, className: cx(toggleInputStyles, iconInputStyles(isDisabled)), disabled: isDisabled, onChange: changeHandler, type: "checkbox", value: value, ...rest })), style: style, testId: testId, useInlineError: useInlineError },
        React.createElement("span", { className: toggleStyles, "data-testid": testId && `${testId}-toggle` })), { ref })));
});
Toggle.displayName = 'Toggle';
